export const DEFAULT_EMAIL_TEMPLATE = "<!doctype html>\n" +
  "<html lang=\"en\" style=\"background-color:#000000;\">\n" +
  "<head>\n" +
  "    <meta name=\"color-scheme\" content=\"dark\">\n" +
  "    <meta name=\"supported-color-schemes\" content=\"dark\">\n" +
  "</head>\n" +
  "<body style=\"margin:0; padding:0; background-color:#000000;\">\n" +
  "<center style=\"width:100%; background-color:#000000;\">\n" +
  "\n" +
  "    <table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n" +
  "        <tr>\n" +
  "            <td align=\"center\" valign=\"top\"\n" +
  "                background=\"https://assets.adnuntius.com/cfbaba/s9c2s2tpqgcwnb1bmyc1dnd2lxnv7knm8ywk9spv1jtddgvr6d.png\"\n" +
  "                style=\"\n" +
  "                background-color:#000000;\n" +
  "                background-image:url('https://assets.adnuntius.com/cfbaba/s9c2s2tpqgcwnb1bmyc1dnd2lxnv7knm8ywk9spv1jtddgvr6d.png');\n" +
  "                background-repeat:no-repeat;\n" +
  "                background-position:center;\n" +
  "                background-size:cover;\n" +
  "                padding:40px 16px;\n" +
  "              \">\n" +
  "\n" +
  "                <!--[if gte mso 9]>\n" +
  "                <v:rect xmlns:v=\"urn:schemas-microsoft-com:vml\" fill=\"true\" stroke=\"false\" style=\"width:600px;height:400px;\">\n" +
  "                    <v:fill type=\"frame\" src=\"https://assets.adnuntius.com/cfbaba/s9c2s2tpqgcwnb1bmyc1dnd2lxnv7knm8ywk9spv1jtddgvr6d.png\" color=\"#eeeeee\"/>\n" +
  "                    <v:textbox inset=\"0,0,0,0\">\n" +
  "                <![endif]-->\n" +
  "\n" +
  "                <table role=\"presentation\" width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n" +
  "                    <tr>\n" +
  "                        <td align=\"center\">\n" +
  "                            <table role=\"presentation\"\n" +
  "                                   width=\"500\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"\n" +
  "                                   style=\"width: 100%; max-width: 500px; background-color: #eee; color: #333; border-radius: 20px 20px 0 0;\">\n" +
  "                                <tr>\n" +
  "                                    <td bgcolor=\"#eee\"\n" +
  "                                        style=\"padding: 20px; border-radius: 20px 20px 0 0; color: #333; background-color: #eee;\">\n" +
  "                                        <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n" +
  "                                            <tr>\n" +
  "                                                <td style=\"border-radius: 20px 20px 0 0;\">\n" +
  "                                                    <img alt=\"Adnuntius logo\" width=\"250\"\n" +
  "                                                         src=\"https://assets.adnuntius.com/cfbcad/1crhrtzd6x27dzrxf7c5fpmvt7myzhz0n1w3gt0q7mv6ynmdn6.png\"\n" +
  "                                                         style=\"display: block; max-width: 100%; height: auto;\">\n" +
  "                                                </td>\n" +
  "                                            </tr>\n" +
  "                                            {{#if heading}}\n" +
  "                                                <tr>\n" +
  "                                                    <td style=\"padding-top: 4px;\">\n" +
  "                                                        {{{heading}}}\n" +
  "                                                    </td>\n" +
  "                                                </tr>\n" +
  "                                            {{/if}}\n" +
  "                                            <tr>\n" +
  "                                                <td style=\"padding-top: 8px;\">\n" +
  "                                                    {{{body}}}\n" +
  "                                                </td>\n" +
  "                                            </tr>\n" +
  "                                            {{#if footer}}\n" +
  "                                                <tr>\n" +
  "                                                    <td style=\"padding-top: 16px;\">\n" +
  "                                                        <hr style=\"border: 1px solid #1bbafb; border-width: 0 0 1px 0;\">\n" +
  "                                                        {{{footer}}}\n" +
  "                                                    </td>\n" +
  "                                                </tr>\n" +
  "                                            {{/if}}\n" +
  "                                        </table>\n" +
  "                                    </td>\n" +
  "                                </tr>\n" +
  "                            </table>\n" +
  "                        </td>\n" +
  "                    </tr>\n" +
  "                </table>\n" +
  "\n" +
  "                <!--[if gte mso 9]>\n" +
  "                </v:textbox>\n" +
  "                </v:rect>\n" +
  "                <![endif]-->\n" +
  "\n" +
  "            </td>\n" +
  "        </tr>\n" +
  "    </table>\n" +
  "\n" +
  "</center>\n" +
  "</body>\n" +
  "</html>\n";